import styled from "styled-components";

const LeftPositionSection = styled.section`
  display: flex;
  justify-content: flex-start;
  width: 100%
`;

export default LeftPositionSection;
